import { getEnvKey } from '@/shared/utils';
import jwt from 'jsonwebtoken';
import Constant from './constant';
import Config from './config';
import { request } from '@/shared/io';
import dayjs from 'dayjs';
import jsrsasign from 'jsrsasign';
const Base64 = require('js-base64').Base64;
export function getParam(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null)
        return decodeURI(r[2]);
    return null;
}
const replaceLoginState = () => {
    const href0 = window.location.href.split('?')[0];
    const href1 = window.location.href.split('?')[1];
    let params = '';
    if (href1) {
        const paths = href1.split('&');
        const pathUrl = paths.filter((item) => !item.includes('access_token') && !item.includes('ACCESS_TOKEN'));
        params = pathUrl.join('&');
    }
    let result = '';
    if (params != '') {
        result = `${href0}?${params}`;
    }
    else {
        result = `${href0}`;
    }
    // window.location.href = result;
    window.history.replaceState({}, '', result);
};
/**
 * 解析token
 * @param accessToken
 * @returns
 */
const getUserInfoToAccessToken = (accessToken) => {
    return new Promise(async (resovle, reject) => {
        const aToken = jwt.decode(accessToken);
        sessionStorage.setItem('USER_INFO', JSON.stringify(aToken.user_info));
        const ct = await getParam('ct');
        if (ct) {
            sessionStorage.setItem('ct', ct);
        }
        return resovle(aToken.user_info);
    });
};
/**
 * 页面跳转
 * @param accessToken
 * @returns
 */
export const toHref = async (accessToken) => {
    return new Promise(async (resovle, reject) => {
        getUserInfoToAccessToken(accessToken).then((res) => {
            replaceLoginState();
            return resovle(res);
        });
    });
};
/**
 * 是否登陆
 */
export function isLogin() {
    if (sessionStorage.getItem(Constant.access_token)) {
        return true;
    }
    return false;
}
// 公钥
export async function getPUBK(mode, authLoginType) {
    // const getpubk = NODE_ENV === 'development' ?  process.env.dotenv[`PUBK`] : window['PUBK']
    const pubk = await getEnvKey('PUBK', mode, authLoginType);
    let basicSecret = 'Basic ' + Base64.encode(`${Config.appId}:${Config.appSecret}`);
    const timestamp = new Date().getTime();
    basicSecret = jsrsasign.hextob64u(
    // @ts-ignore
    jsrsasign.KJUR.crypto.Cipher.encrypt(basicSecret + '\n' + timestamp, jsrsasign.KEYUTIL.getKey(pubk)));
    return basicSecret;
}
export async function saveToken(data) {
    if (!data) {
        window.sessionStorage.clear();
        window.localStorage.clear();
        window.location.href = window.location.origin + window.location.pathname;
        return;
    }
    console.log(data);
    sessionStorage.setItem(Constant.access_token, data.access_token);
    sessionStorage.setItem(Constant.refresh_token, data.refresh_token);
    sessionStorage.setItem(Constant.expires_in, data.expires_in);
    const expires_in = dayjs().add(data.expires_in, 's').unix();
    sessionStorage.setItem(Constant.token_expires_time, expires_in + '');
    sessionStorage.setItem(Constant.user_info, JSON.stringify(data.user_info));
    sessionStorage.setItem(Constant.user_name, data.user_info.name);
    localStorage.setItem('storeSessionData', JSON.stringify({
        userInfo: data.user_info,
        token: data.access_token,
    }));
    sessionStorage.setItem('pt', data.pt || '');
    if (sessionStorage.getItem(Constant.user_info) &&
        sessionStorage.getItem(Constant.access_token)) {
        // window.location.href = Config.urlHref || Config.baseUrl;
    }
    return;
}
export async function accestokenByCode(config, code, basicSecret) {
    const data = await request(config.path + '/oauth/token', {
        data: {
            ct: 1,
            grant_type: 'authorization_code',
            code,
            redirect_uri: config.urlHref || Config.baseUrl,
            fp: localStorage.getItem('fp'),
            v: 1,
        },
        headers: {
            // Authorization: 'Basic ' + BasicSecret,
            Authorization: basicSecret,
        },
        requestType: 'form',
        method: 'post',
    });
    saveToken(data.data);
    return data.data.user_info;
}
/**
 * 删除Token
 */
export async function delToken(e) {
    sessionStorage.removeItem(Constant.access_token);
    sessionStorage.removeItem(Constant.refresh_token);
    sessionStorage.removeItem(Constant.expires_in);
    sessionStorage.removeItem(Constant.token_expires_time);
    sessionStorage.removeItem(Constant.user_info);
    sessionStorage.removeItem(Constant.user_name);
    sessionStorage.removeItem('selectedKeys');
    // sessionStorage.removeItem('noclose');
    sessionStorage.removeItem('openKeys');
    localStorage.removeItem('dict_code');
    localStorage.removeItem('busCategoryIds');
    sessionStorage.removeItem('__init');
    sessionStorage.removeItem('systemId');
    // sessionStorage.clear();
}
// msg 0 或者不传是发消息登出，其他值不发消息，-99 修改密码所有端登出
export async function deleteToken(authUrl, e, s, msg, uId) {
    let userInfo = getUserInfo();
    const storePtValue = sessionStorage.getItem('pt') || 1;
    const userId = uId ? uId : userInfo && userInfo.id ? userInfo.id : '';
    const fp = localStorage.getItem('fp');
    delToken(e);
    const aUrl = authUrl && authUrl != '' ? authUrl : Config.baseUrl + '/auth';
    if (e && e === 1) {
        const userInfoId = userId && userId != '' ? userId : s ? s : '';
        if (userInfoId && userInfoId != '') {
            window.location.href =
                aUrl + `/logout?ct=1&userId=${userInfoId}&fp=${fp}&pt=${storePtValue}`;
        }
    }
    else {
        const userInfoId = userId && userId != '' ? userId : s ? s : '';
        const amsg = msg || 0;
        if (userInfoId && userInfoId != '') {
            // if (navigator.userAgent.indexOf('QQBrowser') != -1) {
            //   request(
            //     aUrl +
            //       `/logout?ct=1&userId=${userInfoId}&fp=${fp}&pt=${storePtValue}&msg=${amsg}`,
            //     {
            //       method: 'get',
            //     }
            //   ).then(() => {
            //     closeWindow()
            //   })
            // } else
            if (navigator.userAgent.indexOf('Firefox') != -1 ||
                navigator.userAgent.indexOf('Chrome') != -1) {
                window.location.href =
                    aUrl +
                        `/logout?ct=1&userId=${userInfoId}&fp=${fp}&pt=${storePtValue}&msg=${amsg}`;
                // setTimeout(() => {
                //   closeWindow();
                // }, 500);
            }
            else {
                fetch(aUrl +
                    `/logout?ct=1&userId=${userInfoId}&fp=${fp}&pt=${storePtValue}&msg=${amsg}`, {
                    method: 'get',
                });
                // .then(() => {
                //   closeWindow();
                // });
            }
            // window.location.href =
            //     aUrl +
            //     `/logout?ct=1&userId=${userInfoId}&fp=${fp}&pt=${storePtValue}&msg=${amsg}`;
        }
    }
}
export const getUserInfo = () => {
    return JSON.parse(sessionStorage.getItem('USER_INFO') || '{}');
};
/**
 * 关闭浏览器窗口
 */
export const closeWindow = (type) => {
    console.log(type);
    if (window.sessionStorage.getItem('noclose')) {
        window.sessionStorage.removeItem('noclose');
        return;
    }
    if (window.location.pathname.includes('portal') && type == 3) {
        return;
    }
    // if (navigator.userAgent.indexOf("MSIE") > 0) {
    //   if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
    //     window.opener = null;
    //     window.close();
    //   } else {
    //     window.open('', '_top');
    //     window?.top?.close();
    //   }
    // } else if (navigator.userAgent.indexOf("Firefox") > 0) {
    //   window.location.href = 'about:blank ';
    // } else {
    //   window.opener = null;
    //   window.open('', '_self', '');
    //   window.close();
    // }
    if (navigator.userAgent.indexOf('Firefox') != -1 ||
        navigator.userAgent.indexOf('Chrome') != -1) {
        open(location, '_self')?.close();
        window.location.href = 'about:blank';
        window.close();
    }
    else {
        window.opener = null;
        window.open('', '_self');
        window.close();
        open(location, '_self')?.close();
    }
    window.close();
};
